import "./WholeHomeRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import WholeHomeRenovationHero from "./sections/WholeHomeRenovationHero";
import RemodelingDecisions from "./sections/RemodelingDecisions";
import TimelineTriggers from "./sections/TimelineTriggers";
import RemodelingProcess from "./sections/RemodelingProcess";
import RemodelingFaq from "./sections/RemodelingFaq";
import RemodelingEstimate from "./sections/RemodelingEstimate";
import RemodelingCtaBand from "./sections/RemodelingCtaBand";
import EstimateForm from "./sections/EstimateForm";
import Footer from "@/reusable_sections/Footer";
export default function WholeHomeRemodelingPage() {
  return <div>
      <Header />
      <WholeHomeRenovationHero />
      <RemodelingDecisions />
      <RemodelingCtaBand />
      <TimelineTriggers />
      <RemodelingProcess />
      <RemodelingFaq />
      <EstimateForm />
      <RemodelingEstimate />
      <Footer />
    </div>;
}